import apiClient from './apiClient';

export interface LabOrderWithResults {
  id: string;
  patient_id: string | null;
  visit_id: string | null;
  clinic_id: string;
  status: string;
  source: string;
  document_url: string | null;
  document_storage_key: string | null;
  external_ref: string | null;
  lab_provider: string | null;
  ordered_at: string;
  received_at: string | null;
  verified_at: string | null;
  verified_by: string | null;
  created_at: string;
  results?: { id: string; name: string; result_type: string; document_url: string | null }[];
}

export async function getPatientLabResults(patientId: string, clinicId?: string): Promise<LabOrderWithResults[]> {
  const params = clinicId ? { clinicId } : {};
  const res = await apiClient.get<{ success: boolean; data: LabOrderWithResults[] }>(`/patients/${patientId}/lab-results`, { params });
  return res.data.data || [];
}

export async function markLabResultReviewed(orderId: string, notes?: string): Promise<LabOrderWithResults> {
  const res = await apiClient.post<{ success: boolean; data: LabOrderWithResults }>(`/lab-results/${orderId}/review`, { notes });
  return res.data.data!;
}

export async function attachLabResultToVisit(orderId: string, visitId: string): Promise<LabOrderWithResults> {
  const res = await apiClient.post<{ success: boolean; data: LabOrderWithResults }>(`/lab-results/${orderId}/attach-to-visit`, { visitId });
  return res.data.data!;
}

export async function assignLabResultToPatient(orderId: string, patientId: string, visitId?: string): Promise<LabOrderWithResults> {
  const res = await apiClient.post<{ success: boolean; data: LabOrderWithResults }>(`/lab-results/${orderId}/assign`, { patientId, visitId });
  return res.data.data!;
}
